<div class="card-component dsd-d-flex dsd-fg-1" [ngClass]="'theme-' + theme">
  <div class="header pt-16 pb-16 pr-16-24 pl-16-24">
    <ng-content select="[header]"></ng-content>
  </div>
  <div class="content pt-16 pb-16 pr-16-24 pl-16-24 dsd-d-flex dsd-fg-1">
    <ng-content></ng-content>
  </div>
</div>
